import script from "./SoftswissLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./SoftswissLinks.vue?vue&type=script&setup=true&lang=js"

import "./SoftswissLinks.vue?vue&type=style&index=0&id=843f4fdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-843f4fdc"]])

export default __exports__